import { render } from "./ExportExcel.vue?vue&type=template&id=ae95e6e4"
import script from "./ExportExcel.vue?vue&type=script&lang=js"
export * from "./ExportExcel.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__